var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPinAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99064 0C2.6883 0 0 2.756 0 6.152C0 10.056 5.35039 15.6 5.57504 15.82C5.69022 15.9353 5.84215 15.9995 6 15.9995C6.15785 15.9995 6.30978 15.9353 6.42496 15.82C6.64961 15.584 12 10.056 12 6.152C11.9813 2.756 9.3117 0 5.99064 0ZM5.99064 9.38C5.17298 9.39823 4.38201 9.06888 3.79156 8.46433C3.20111 7.85979 2.8595 7.02951 2.84181 6.156C2.86049 5.28212 3.20216 4.45166 3.79217 3.84607C4.38218 3.24047 5.17257 2.90897 5.99064 2.924C6.80829 2.90685 7.59886 3.23723 8.1886 3.84252C8.77835 4.44781 9.11901 5.27849 9.13573 6.152C9.11901 7.02551 8.77835 7.85619 8.1886 8.46148C7.59886 9.06677 6.80829 9.39715 5.99064 9.38Z",
    fill: "#8099A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinAlt);
export default __webpack_public_path__ + "static/media/map-pin-alt.cfa69712251df8b2b68ecebea3bb8513.svg";
export { ForwardRef as ReactComponent };